export default __webpack_public_path__ + "static/media/Lily.d6eb7953.png";